import React, { useRef, useEffect, useLayoutEffect, useState, useCallback } from 'react';

import ConstData from '../../../lib/ConstData';
import { enTokenCMD, enDrawingMode } from '../../../lib/classTalk/CodeEnum';

import { initImageSrc } from '../../../lib/RabbitmqClient';

// 260819: 마커(반투명) 모드에서 실시간으로 그릴 때 stroke()가 여러 번 나뉘어 호출되면서
// 구간이 겹치는 이음매마다 알파가 중복 합성되어 "진한 점~연한 선" 형태로 얼룩지는 문제 수정.
// isOpaquePaint=true로 호출되는 실시간 드로잉 경로는 캔버스에는 항상 불투명(A=1)으로 그리고,
// 대신 완성된 스트로크를 담는 canvas(cur_div) 자체에 CSS opacity로 투명도를 적용해서
// 이음매 이중합성 없이 처음부터 균일하게 반투명하게 보이도록 함 ... by Easy
const createInkStrokeAnnot = (scale, path, context, isOpaquePaint) => {
    //alert('create ink stroke');
    let cur_annot = {};
    cur_annot.path = path;

    let drawingAttributes = path.stroke.DrawingAttributes;
    let offsetX = Math.round(path.minPoints.x - (drawingAttributes.lineWidth / 2));
    let offsetY = Math.round(path.minPoints.y - (drawingAttributes.lineWidth / 2));
    let boundWidth = Math.round((path.maxPoints.x - path.minPoints.x) + drawingAttributes.lineWidth);
    let boundHeight = Math.round((path.maxPoints.y - path.minPoints.y) + drawingAttributes.lineWidth);

    if (offsetX < 0) offsetX = 0;
    if (offsetY < 0) offsetY = 0;

    let offsetX_rate = Math.round(offsetX * scale.width);
    let offsetY_rate = Math.round(offsetY * scale.height);
    let boundWidth_rate = Math.round(boundWidth * scale.width);
    let boundHeight_rate = Math.round(boundHeight * scale.height);

    let cur_div = document.createElement('canvas');
    cur_div.style.position = 'absolute';
    cur_div.style.left = offsetX_rate + 'px';
    cur_div.style.top = offsetY_rate + 'px';
    cur_div.width = boundWidth_rate;
    cur_div.height = boundHeight_rate;
    cur_div.style.zIndex = 30;

    let imgData = context.getImageData(offsetX_rate, offsetY_rate, boundWidth_rate, boundHeight_rate);
    cur_annot.imgData = imgData;

    let cur_ctx = cur_div.getContext('2d');
    cur_ctx.putImageData(imgData, 0, 0);
    cur_annot.div = cur_div;

    // 260819: 실시간 드로잉 경로(isOpaquePaint=true)는 픽셀 자체가 불투명하게 캡처되었으므로,
    // 여기서 CSS opacity로 원래 의도한 투명도(Color.A)를 적용해줌 ... by Easy
    if (isOpaquePaint) {
        cur_div.style.opacity = (drawingAttributes.Color.A !== undefined ? drawingAttributes.Color.A : 1);
    }

    let drawingCanvas = document.getElementById('canvas-area');
    drawingCanvas.appendChild(cur_div);

    context.clearRect(0, 0, context.canvas.width, context.canvas.height);

    // 260819: 그리는 동안 실시간 투명도 표시를 위해 걸어둔 캔버스 레이어의 CSS opacity를
    // 스트로크 커밋 후 원복(다음 스트로크 시작 시 initDraw류 함수에서 다시 설정됨) ... by Easy
    context.canvas.style.opacity = '1';

    return cur_annot;
}

const deleteInk = (annotList, startPosition, endPosition, callback) => {
    if (annotList === undefined || annotList === null) return;

    let cur_annotList = [];
    cur_annotList = annotList;

    let drawingCanvas = document.getElementById('canvas-area');

    annotList.forEach(
        (annot, index) => {
            let points = annot.path.stroke.StylusPoints;
            let lastIndex = 0;

            lastIndex = points.length - 1;
            if ((points[0].x === startPosition.x) && (points[0].y === startPosition.y) &&
                (points[lastIndex].x === endPosition.x) && (points[lastIndex].y === endPosition.y)) {
                drawingCanvas.removeChild(annot.div);
                cur_annotList.splice(index, 1);
            }
        }
    );

    return cur_annotList;
}

const LiveDrawingCanvas = ({ rcvPath, androidPenPath, rcvStroke, rcvStrokes, drawingMode, tipSize, tipColor, isClearInkStroke, isMixedClassMember, isLiveMixedAlertModalOpened, isGuestYn, isLiveGuestAlertModalOpened, handleSelectedDrawingToolFunc }) => {
    const { rcvCmd, rcvMode, rcvColor, rcvWidth, rcvPoint1, rcvPoint2 } = rcvPath;

    const annotList = useRef([]);

    const lDrawingMode = useRef(drawingMode);
    const lDrawingTipSize = useRef(tipSize);
    const lDrawingTipColor = useRef(tipColor);

    const imgData = useRef(null);
    const bgImgSize = useRef({ width: ConstData.SCREEN_RATE.WIDTH, height: ConstData.SCREEN_RATE.HEIGHT });

    const scale_x = useRef(1);
    const scale_y = useRef(1);

    const targetRef = useRef();
    const bgCanvasRef = useRef(null);

    const canvasRef = useRef(null);
    const mainCtxRef = useRef(null);
    const pathRef = useRef(null);

    const sCanvasRef = useRef(null);
    const sCtxRef = useRef(null);
    const serverPathRef = useRef(null);

    const rcvCanvasRef = useRef(null);
    const rcvCtxRef = useRef(null);

    const pCanvasRef = useRef(null);
    const pCtxRef = useRef(null);
    const penPathRef = useRef(null);

    const aCanvasRef = useRef(null);
    const aCtxRef = useRef(null);
    const aPenPathRef = useRef(null);

    useLayoutEffect(() => {
        console.log("(1) LiveDrawingCanvas - useLayoutEffect called...");
        console.log("(1) LiveDrawingCanvas - call initCanvasSize");
        initCanvasSize();
        console.log("(1) LiveDrawingCanvas - call onChangeCanvasSize");
        onChangeCanvasSize();
    }, []);

    useLayoutEffect(() => {
        /* if (!isMixedClassMember && isGuestYn !== "Y") {
            console.log("(2) LiveDrawingCanvas - not mixed class member & guest ...");
            return;
        } else {
            console.log("(2) LiveDrawingCanvas - mixed class member or guest ...");
        }

        if (isMixedClassMember) {
            if (!isLiveMixedAlertModalOpened) {
                console.log("(2-1) LiveDrawingCanvas - useLayoutEffect called...");
                console.log("(2-1) LiveDrawingCanvas - call initCanvasSize");
                initCanvasSize();
                console.log("(2-1) LiveDrawingCanvas - call onChangeCanvasSize");
                onChangeCanvasSize();
            }
        } else {
            if (!isLiveGuestAlertModalOpened) {
                console.log("(2-2) LiveDrawingCanvas - useLayoutEffect called...");
                console.log("(2-2) LiveDrawingCanvas - call initCanvasSize");
                initCanvasSize();
                console.log("(2-2) LiveDrawingCanvas - call onChangeCanvasSize");
                onChangeCanvasSize();
            }
        } */

        // 테스트 후 이 부분 코드 없애기 ... by hjkim 20260102
        if (!isMixedClassMember && isGuestYn !== "Y") {
            console.log("(2) LiveDrawingCanvas - not mixed class member & guest ...");
            return;
        } else {
            console.log("(2) LiveDrawingCanvas - mixed class member or guest ...");
        }

        // 20260102 ... 믹스드클래스 멤버 & 게스트 멤버 구분없이 모달 창이 열려있는지 여부로 판단하도록 수정 ... by hjkim
        if (!isLiveMixedAlertModalOpened && !isLiveGuestAlertModalOpened) {
            console.log("(2-1) LiveDrawingCanvas - useLayoutEffect called...");
            console.log("(2-1) LiveDrawingCanvas - call initCanvasSize");
            initCanvasSize();
            console.log("(2-1) LiveDrawingCanvas - call onChangeCanvasSize");
            onChangeCanvasSize();
        }
    }, [isMixedClassMember, isLiveMixedAlertModalOpened, isGuestYn, isLiveGuestAlertModalOpened]);

    useEffect(() => {
        initCanvasSize();
        onChangeCanvasSize();

        // isMobileDevice 체크가 의미 없었음. 항상 pointer 이벤트로 처리하게 수정 ... by ykhan 241108
        canvasRef.current.addEventListener("pointerdown", initDraw);
        canvasRef.current.addEventListener("pointermove", draw);
        canvasRef.current.addEventListener("pointerup", finishDraw);

        // pointercancel 이벤트 추가 - 터치가 취소될 때 처리를 위해 추가 ... by hjkim 20251016
        canvasRef.current.addEventListener("pointercancel", handlePointerCancel);

        // drawing이 이상하게 동작한다면 여기를 보시오 ... by ykhan 241108
        // if (isMobileDevice) {
        //     canvasRef.current.addEventListener("pointerdown", initDraw);
        //     canvasRef.current.addEventListener("pointermove", draw);
        //     canvasRef.current.addEventListener("pointerup", finishDraw);
        // } else {
        //     canvasRef.current.addEventListener("mousedown", initDraw);
        //     canvasRef.current.addEventListener("mousemove", draw);
        //     canvasRef.current.addEventListener("mouseup", finishDraw);
        //     canvasRef.current.addEventListener("mouseout", finishDraw);
        // }

        window.addEventListener('resize', onChangeCanvasSize);
        window.addEventListener('message', onRcvExtensionMessage);

        return () => {
            window.removeEventListener('resize', onChangeCanvasSize);
            window.removeEventListener('message', onRcvExtensionMessage);

            // 아래에서 ios인 경우에만 이벤트 리스너를 등록했으니, 제거도 ios인 경우에만 되도록 수정 ... by hjkim 20251017
            if (navigator.userAgent.toLowerCase().indexOf('iphone') > -1 || (navigator.userAgent.toLowerCase().indexOf('macintosh') > -1 && navigator.maxTouchPoints > 2)) {
                document.removeEventListener('touchmove', preventBehavior, { passive: false });
            }

            // canvasRef 체크
            if (canvasRef && canvasRef.current) {
                canvasRef.current.removeEventListener("pointerdown", initDraw);
                canvasRef.current.removeEventListener("pointermove", draw);
                canvasRef.current.removeEventListener("pointerup", finishDraw);

                // pointercancel 이벤트 리스너 제거 추가 ... by hjkim 20251016
                canvasRef.current.removeEventListener("pointercancel", handlePointerCancel);

                // canvasRef 초기화
                canvasRef.current = null;
            }
        }
    }, []);

    useEffect(() => {
        initImageSrc(getImgSrcData);
    }, [bgCanvasRef]);

    useEffect(() => {
        switch (rcvCmd) {
            case enTokenCMD.Ink_SDn:
                server_initDraw(rcvPoint1);
                break;

            case enTokenCMD.Ink_SM:
                server_draw(rcvPoint1);
                break;

            case enTokenCMD.Ink_SDM:
                console.log("double move - ", rcvPoint1, rcvPoint2);
                break;

            case enTokenCMD.Ink_SUp:
                server_finishDraw(rcvPoint1);
                break;

            case enTokenCMD.Ink_Erase1:
                server_eraseStroke(rcvPoint1, rcvPoint2);
                break;

            case enTokenCMD.Ink_Mode:
                // console.log("change mode - ", rcvMode);
                break;

            case enTokenCMD.Ink_Color:
                // console.log("change color - ", rcvColor);
                break;

            case enTokenCMD.Ink_Tip:
                // console.log("change width - ", rcvWidth);
                break;

            case enTokenCMD.rq_PageClear:
                initClearImageSrc();
                clear();
                break;

            default:
                break;
        }
    }, [rcvCmd, rcvPoint1, rcvPoint2]);

    useEffect(() => {
        lDrawingMode.current = drawingMode;
        lDrawingTipSize.current = tipSize;
        lDrawingTipColor.current = tipColor;

        let drawingCanvas = document.getElementById('canvas-area');

        if (lDrawingMode.current === enDrawingMode.Hand) {
            // drawingCanvas.style.overflowY = 'scroll';
            drawingCanvas.classList.remove('draw'); // ← touch-action만 pan-x/pan-y로 바뀜

            // Hand 모드: 캔버스 레이어(#canvas-area)가 터치를 가로채지 않도록
            // pointer-events를 꺼서, 아래(비디오)/위 레이어로 터치가 그대로 통과되게 함
            drawingCanvas.style.pointerEvents = 'none';

            // 아래에서 ios인 경우에만 이벤트 리스너를 등록했으니, 제거도 ios인 경우에만 되도록 수정 ... by hjkim 20251017
            if (navigator.userAgent.toLowerCase().indexOf('iphone') > -1 || (navigator.userAgent.toLowerCase().indexOf('macintosh') > -1 && navigator.maxTouchPoints > 2)) {
                document.removeEventListener('touchmove', preventBehavior, { passive: false });
            }

            // Hand 모드에서도 pull-to-refresh 방지
            // CSS로 처리하는 것이 더 좋지만, JS로도 가능
            drawingCanvas.style.overscrollBehavior = 'contain';
        } else {
            // drawingCanvas.style.overflowY = 'hidden';

            // 그리기 모드로 복귀 시, 캔버스가 다시 터치를 받도록 복원
            drawingCanvas.style.pointerEvents = 'auto';

            if ((enDrawingMode.Pen <= drawingMode && drawingMode <= enDrawingMode.Marker) || drawingMode === enDrawingMode.EraseStroke) {
                drawingCanvas.classList.add('draw');
            }

            if (navigator.userAgent.toLowerCase().indexOf('iphone') > -1 || (navigator.userAgent.toLowerCase().indexOf('macintosh') > -1 && navigator.maxTouchPoints > 2)) {
                document.addEventListener('touchmove', preventBehavior, { passive: false });
            }
        }
    }, [drawingMode, tipSize, tipColor]);

    // ============================================================
    // [임시 진단코드] Hand 모드인데 캔버스가 터치를 가로채는 순간을 즉시 alert로 알림
    // pointer-events 수정 적용 후 문제 없는 게 확인되면 이 블록은 통째로 제거하거나
    // DEBUG_HAND_MODE_TOUCH 를 false로 바꿔서 꺼두세요 ... by Easy
    // ============================================================
    useEffect(() => {
        const DEBUG_HAND_MODE_TOUCH = true; // 끄고 싶을 땐 false로

        if (!DEBUG_HAND_MODE_TOUCH) return;

        const detectHandModeCanvasCapture = (e) => {
            // Hand 모드가 아니면 정상 상황이므로 무시
            if (lDrawingMode.current !== enDrawingMode.Hand) return;

            // 터치 타겟이 draw-canvas 계열이 아니면(=정상적으로 통과됐으면) 무시
            if (!e.target.classList || !e.target.classList.contains('draw-canvas')) return;

            // 여기까지 왔다는 건 = Hand 모드인데 캔버스가 여전히 터치를 가로채고 있다는 뜻 (버그 재현!)
            alert(
                '[HAND MODE 버그 재현]\n' +
                'target: ' + (e.target.id || e.target.className) + '\n' +
                'pointerType: ' + e.pointerType + '\n' +
                'time: ' + new Date().toLocaleTimeString()
            );
        };

        // capture: true → 다른 어떤 핸들러보다 먼저 실행되도록 캡처링 단계에서 감지
        document.addEventListener('pointerdown', detectHandModeCanvasCapture, true);

        return () => {
            document.removeEventListener('pointerdown', detectHandModeCanvasCapture, true);
        };
    }, []); // lDrawingMode는 ref라서 deps 필요 없음, 마운트 시 1회만 등록

    useEffect(() => {
        draw1Stroke(rcvStroke);
    }, [rcvStroke]);

    useEffect(() => {
        drawNStroke(rcvStrokes);
    }, [rcvStrokes]);

    useEffect(() => {
        // console.log('useEffect() - androidPenPath - ', androidPenPath);

        switch (androidPenPath.cmd) {
            case enTokenCMD.Ink_DDn:
                android_pen_initDraw(androidPenPath.point1);
                break;

            case enTokenCMD.Ink_DM:
                android_pen_draw(androidPenPath.point1);
                break;

            case enTokenCMD.Ink_DDM:
                android_pen_double_draw(androidPenPath.point1, androidPenPath.point2);
                break;

            case enTokenCMD.Ink_DUp:
                android_pen_finishDraw(androidPenPath.point1);
                break;

            default:
                break;
        }
    }, [androidPenPath.cmd, androidPenPath.point1, androidPenPath.point2]);

    useEffect(() => {
        if (isClearInkStroke) {
            clear();
        }
    }, [isClearInkStroke]);

    useEffect(() => {
        // 테스트 후 이 부분 코드 없애기 ... by hjkim 20260102
        if (!isMixedClassMember && isGuestYn !== "Y") {
            console.log("(2) LiveDrawingCanvas - not mixed class member & guest ...");
            return;
        } else {
            console.log("(2) LiveDrawingCanvas - mixed class member or guest ...");
        }

        // 20260102 ... 믹스드클래스 멤버 & 게스트 멤버 구분없이 모달 창이 열려있는지 여부로 판단하도록 수정 ... by hjkim
        if (!isLiveMixedAlertModalOpened && !isLiveGuestAlertModalOpened) {
            console.log("(2-1) LiveDrawingCanvas - useLayoutEffect called...");
            console.log("(2-1) LiveDrawingCanvas - call initCanvasSize");
            initCanvasSize();
            console.log("(2-1) LiveDrawingCanvas - call onChangeCanvasSize");
            onChangeCanvasSize();
        }
    }, [isMixedClassMember, isLiveMixedAlertModalOpened, isGuestYn, isLiveGuestAlertModalOpened]);

    const isMobileDevice = () => {
        let isMobileDeviceFlag = false;

        if (navigator.userAgent.toLowerCase().indexOf('android') > -1) isMobileDeviceFlag = true;
        if (navigator.userAgent.toLowerCase().indexOf('iphone') > -1) isMobileDeviceFlag = true;
        if (navigator.userAgent.toLowerCase().indexOf('macintosh') > -1 && navigator.maxTouchPoints > 2) isMobileDeviceFlag = true;

        return isMobileDeviceFlag;
    }

    const preventBehavior = useCallback((e) => {
        e.preventDefault();
    }, []);

    const initCanvasSize = () => {
        bgCanvasRef.current.width = bgImgSize.current.width;
        bgCanvasRef.current.height = bgImgSize.current.height;

        canvasRef.current.width = bgImgSize.current.width;
        canvasRef.current.height = bgImgSize.current.height;

        sCanvasRef.current.width = bgImgSize.current.width;
        sCanvasRef.current.height = bgImgSize.current.height;

        aCanvasRef.current.width = bgImgSize.current.width;
        aCanvasRef.current.height = bgImgSize.current.height;

        pCanvasRef.current.width = bgImgSize.current.width;
        pCanvasRef.current.height = bgImgSize.current.height;

        rcvCanvasRef.current.width = bgImgSize.current.width;
        rcvCanvasRef.current.height = bgImgSize.current.height;
    }

    const onChangeCanvasSize = () => {
        let newWidth, newHeight;

        if (targetRef.current === undefined || targetRef.current === null) return;

        if (bgImgSize.current.width > bgImgSize.current.height) { //가로 문서
            scale_x.current = targetRef.current.offsetWidth / bgImgSize.current.width;
            scale_y.current = targetRef.current.offsetHeight / bgImgSize.current.height;
        } else {
            scale_x.current = targetRef.current.offsetWidth / bgImgSize.current.width;
            scale_y.current = scale_x.current;
        }

        if (bgImgSize.current.width > bgImgSize.current.height) { // 가로 문서
            newWidth = bgImgSize.current.width * scale_x.current;
            newHeight = bgImgSize.current.height * scale_y.current;
        } else {
            newWidth = bgImgSize.current.width * scale_x.current;
            newHeight = bgImgSize.current.height * scale_x.current;
        }

        bgCanvasRef.current.width = newWidth;
        bgCanvasRef.current.height = newHeight;

        canvasRef.current.width = newWidth;
        canvasRef.current.height = newHeight;

        sCanvasRef.current.width = newWidth;
        sCanvasRef.current.height = newHeight;

        aCanvasRef.current.width = newWidth;
        aCanvasRef.current.height = newHeight;

        pCanvasRef.current.width = newWidth;
        pCanvasRef.current.height = newHeight;

        rcvCanvasRef.current.width = newWidth;
        rcvCanvasRef.current.height = newHeight;

        onChangeBackgroundImage();
        onResizeAnnot();

        //handleSelectedDrawingToolFunc({ selectedFunc: "SET_OFFSET", data: { offset: { x: lOffsetX.current, y: lOffsetY.current } } });
    }

    const onChangeBackgroundImage = () => {
        
        if (imgData.current) {
            let ctx = bgCanvasRef.current.getContext('2d');

            console.log("onChangeBackgroundImage - imgData size :", imgData.current.width, imgData.current.height);
            console.log("onChangeBackgroundImage - bgCanvasRef size : ", bgCanvasRef.current.width, bgCanvasRef.current.height);

            // let img = new Image();
            // img.onload = () => {
            //     ctx.drawImage(img, 0, 0, bgCanvasRef.current.width, bgCanvasRef.current.height);
            // }
            // img.src = imgData.current;

            ctx.clearRect(0, 0, bgCanvasRef.current.width, bgCanvasRef.current.height);
            ctx.drawImage(imgData.current, 0, 0, bgCanvasRef.current.width, bgCanvasRef.current.height);
        }
    }

    const onResizeAnnot = () => {
        if (annotList.current === undefined || annotList.current === null || annotList.current.length === 0) return;

        let drawingCanvas = document.getElementById('canvas-area');

        let arr = [];
        let drawingAttributes = {};

        annotList.current.forEach(annot => {
            drawingCanvas.removeChild(annot.div);

            drawingAttributes = annot.path.stroke.DrawingAttributes;

            mainCtxRef.current = canvasRef.current.getContext('2d');
            mainCtxRef.current.lineWidth = drawingAttributes.lineWidth;
            mainCtxRef.current.lineJoin = 'round';
            mainCtxRef.current.lineCap = 'round';
            mainCtxRef.current.strokeStyle = 'rgba(' + drawingAttributes.Color.R + ', ' + drawingAttributes.Color.G + ', ' + drawingAttributes.Color.B + ', ' + drawingAttributes.Color.A + ')';
            mainCtxRef.current.fillStyle = 'rgba(' + drawingAttributes.Color.R + ', ' + drawingAttributes.Color.G + ', ' + drawingAttributes.Color.B + ', ' + drawingAttributes.Color.A + ')';

            // 20260701: 이미 다 그려진(paintedCount가 끝까지 찬) path를 리사이즈로 재렌더링하는
            // 경우이므로 처음부터 다시 그리도록 paintedCount를 리셋하고 isFinal로 끝점까지 확정
            annot.path.paintedCount = 0;
            onPaint(mainCtxRef.current, annot.path, undefined, true);

            let newAnnot = createInkStrokeAnnot({ width: scale_x.current, height: scale_y.current }, annot.path, mainCtxRef.current);
            arr.push(newAnnot);
        });

        annotList.current = arr;
    }

    const getImgSrcData = (imgSrc) => {
        imgData.current = imgSrc;
        console.log("getImgSrcData - imgSrc : ", imgSrc.width, imgSrc.height);
        if (imgSrc.width > imgSrc.height) {
            bgImgSize.current = { width: 1122, height: 793 };
        } else {
            bgImgSize.current = { width: 793, height: 1122 };
        }
        //bgImgSize.current = { width: imgSrc.width, height: imgSrc.height };

        onChangeCanvasSize();
    }

    const initClearImageSrc = () => {
        imgData.current = null;
        bgImgSize.current = { width: ConstData.SCREEN_RATE.WIDTH, height: ConstData.SCREEN_RATE.HEIGHT };

        let ctx = bgCanvasRef.current.getContext('2d');
        ctx.clearRect(0, 0, bgCanvasRef.current.width, bgCanvasRef.current.height);

        ctx.fillStyle = "#fffdf5";
        ctx.fillRect(0, 0, bgCanvasRef.current.width, bgCanvasRef.current.height);

        onChangeCanvasSize();
    }

    const erase = (curPath, position) => {
        if (annotList.current.length < 1) return;

        let drawingCanvas = document.getElementById('canvas-area');

        let min = {
            x: curPath.preEraserPoint.x > position.x ? position.x : curPath.preEraserPoint.x,
            y: curPath.preEraserPoint.y > position.y ? position.y : curPath.preEraserPoint.y
        };

        let max = {
            x: curPath.preEraserPoint.x < position.x ? position.x : curPath.preEraserPoint.x,
            y: curPath.preEraserPoint.y < position.y ? position.y : curPath.preEraserPoint.y
        };

        let cur_annotList = [];

        annotList.current.forEach(
            (annot, index) => {
                let pointSet = annot.path.stroke.StylusPoints;
                let lineWidth = annot.path.stroke.DrawingAttributes.lineWidth / 2;
                let dx = 0, dy = 0, dist = 0;
                let check = true;

                for (let i = 0; i < pointSet.length; i++) {
                    dx = position.x - pointSet[i].x;
                    dy = position.y - pointSet[i].y;
                    dist = Math.sqrt(dx * dx + dy * dy);

                    if (dist < lineWidth) {
                        if (drawingCanvas.hasChildNodes(annot.div)) {
                            //console.log("clear 1");
                            drawingCanvas.removeChild(annot.div);
                            check = false;

                            cur_annotList.push(index);

                            break;
                        }
                    }
                }

                if (check) {
                    let sMin = annot.path.minPoints;
                    let sMax = annot.path.maxPoints;
                    let rect = null, imgData = null;
                    let length = 0, idx = 0;

                    if ((sMin.x <= max.x) && (sMin.y <= max.y) && (sMax.x >= min.x) && (sMax.y >= min.y)) {
                        rect = {
                            mn_x: Math.round((Math.max(min.x, sMin.x) - sMin.x) * scale_x.current),
                            mn_y: Math.round((Math.max(min.y, sMin.y) - sMin.y) * scale_y.current),
                            mx_x: Math.round((Math.min(max.x, sMax.x) - sMin.x) * scale_x.current),
                            mx_y: Math.round((Math.min(max.y, sMax.y) - sMin.y) * scale_y.current)
                        };

                        imgData = annot.div.getContext('2d').getImageData(rect.mn_x, rect.mn_y, (rect.mx_x - rect.mn_x) + 1, (rect.mx_y - rect.mn_y) + 1);
                        length = imgData.data.length;

                        while (check && idx < length) {
                            if (imgData.data[idx] !== 0) {
                                if (drawingCanvas.hasChildNodes(annot.div)) {
                                    drawingCanvas.removeChild(annot.div);
                                    check = false;

                                    //console.log('clear 2');
                                }
                            }

                            idx = idx + 1;
                        }

                        if (!check) {
                            cur_annotList.push(index);
                        }
                    }
                }
            }
        );

        let seq = cur_annotList.pop();

        while (seq !== undefined) {
            annotList.current.splice(seq, 1);
            seq = cur_annotList.pop();
        }
    }

    const clear = () => {
        if (mainCtxRef.current === undefined || mainCtxRef.current === null) mainCtxRef.current = canvasRef.current.getContext('2d');

        let drawingCanvas = document.getElementById('canvas-area');

        mainCtxRef.current.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);

        annotList.current.forEach(annot => {
            drawingCanvas.removeChild(annot.div);
        });

        annotList.current = [];

        handleSelectedDrawingToolFunc({ selectedFunc: "CLEAR_SUCCESS" });
    }

    // 20260701 최적화: 매 포인트마다 캔버스를 clearRect 후 StylusPoints 전체를
    // 처음부터 다시 그리던 방식(O(n^2))을 제거하고, 새로 들어온 구간만 이어 그리는
    // 증분(incremental) 렌더링으로 변경 (O(n)). curPath.paintedCount에 "이미 캔버스에
    // 커밋된 포인트 인덱스"를 저장해두고, 다음 호출부터는 그 지점부터만 이어 그린다.
    // 스무딩 특성상 항상 "직전 두 점의 중점"까지만 커밋하고 실제 마지막 점은
    // isFinal=true(스트로크 종료/일괄 렌더 시)로 호출될 때 한 번만 확정해서 그린다.
    // (참고: position을 넘기면 이 함수 내부에서 1회만 push한다 — 호출부에서 별도로
    // StylusPoints.push를 하면 같은 좌표가 중복 push되어 꺾임이 생기니 하지 말 것)
    const onPaint = (ctx, curPath, position, isFinal) => {
        let pointList = curPath.stroke.StylusPoints;

        if (position !== undefined && position !== null) {
            pointList.push(position);
        }

        if (pointList.length === 0) return;

        if (curPath.paintedCount === undefined) curPath.paintedCount = 0;

        ctx.save();
        ctx.scale(scale_x.current, scale_y.current);

        if (pointList.length < 3) {
            if (!isFinal) {
                // 아직 곡선을 시작하기엔 포인트가 부족 - 즉각적인 피드백용 점만 표시
                ctx.beginPath();
                ctx.arc(pointList[0].x, pointList[0].y, ctx.lineWidth / 2, 0, Math.PI * 2, !0);
                ctx.fill();
                ctx.closePath();
                ctx.restore();
                return;
            }

            if (pointList.length === 1) {
                // 탭(클릭)처럼 점 하나로 끝난 스트로크
                ctx.beginPath();
                ctx.arc(pointList[0].x, pointList[0].y, ctx.lineWidth / 2, 0, Math.PI * 2, !0);
                ctx.fill();
                ctx.closePath();
                ctx.restore();
                return;
            }

            // 점 2개로 끝난 짧은 스트로크는 직선으로 연결
            ctx.beginPath();
            ctx.moveTo(pointList[0].x, pointList[0].y);
            ctx.lineTo(pointList[1].x, pointList[1].y);
            ctx.stroke();
            ctx.restore();
            return;
        }

        ctx.beginPath();

        if (curPath.paintedCount === 0) {
            ctx.moveTo(pointList[0].x, pointList[0].y);
            curPath.paintedCount = 1;
        } else {
            // 이전 호출에서 멈춘 중점(마지막으로 캔버스에 실제로 찍힌 위치)부터 이어 그림
            let p1 = pointList[curPath.paintedCount - 1];
            let p2 = pointList[curPath.paintedCount];
            ctx.moveTo((p1.x + p2.x) / 2, (p1.y + p2.y) / 2);
        }

        let k = curPath.paintedCount;
        for (; k < pointList.length - 1; k++) {
            let c = (pointList[k].x + pointList[k + 1].x) / 2;
            let d = (pointList[k].y + pointList[k + 1].y) / 2;

            ctx.quadraticCurveTo(pointList[k].x, pointList[k].y, c, d);
        }
        curPath.paintedCount = k;

        if (isFinal) {
            // 스트로크가 끝났거나(펜업) 완성된 스트로크를 한 번에 그리는 경우 -
            // 중점에서 멈추지 않고 실제 마지막 점까지 확정해서 그린다.
            let last = pointList.length - 1;
            ctx.quadraticCurveTo(
                pointList[last - 1].x,
                pointList[last - 1].y,
                pointList[last].x,
                pointList[last].y
            );
        }

        ctx.stroke();
        ctx.restore();
    }

    // pointercancel 핸들러 추가
    const handlePointerCancel = (e) => {
        console.log("pointercancel - type:", e.type, ", pointerType:", e.pointerType, "pointerId:", e.pointerId);
        /* if (pathRef.current) {
            console.log("pointercancel - isDrawing[", pathRef.current.isDrawing, "]");
            console.log("pointercancel - id[", pathRef.current.id, "]");
            console.log("pointercancel - pointerType[", pathRef.current.pointerType, "]");
        }

        // 현재 그리기 세션과 동일한 포인터가 취소된 경우에만 처리
        if (pathRef.current && pathRef.current.isDrawing && pathRef.current.id === e.pointerId) {
            // 그리기 중단 - pathRef 초기화하지 않고 계속 진행
            console.log("pointercancel - but continue drawing");
        } */
    }

    const initDraw = (e) => {
        // if (lDrawingMode === enDrawingMode.Hand) return;
        if (lDrawingMode === enDrawingMode.Hand) {
            console.log("initDraw - lDrawingMode is Hand ...");
            return;
        }

        // Palm rejection: 이미 그리기가 진행 중이면 다른 포인터 무시
        if (pathRef.current && pathRef.current.isDrawing) {
            // 펜으로 그리는 중 터치 입력은 완전히 무시
            if ((pathRef.current.pointerType === 'pen' && e.pointerType === 'touch')) {
                console.log("initDraw - ignored: pen drawing, palm touch detected");
                return;
            }

            if (e.pointerId !== pathRef.current.id) {
                // 손바닥이 먼저 닿고 펜으로 그리는 입력은 pointerId가 다르면 pen의 pointerId로 변경하고, 입력을 무시하지 않음
                if (pathRef.current.pointerType === 'touch' && e.pointerType === 'pen') {
                    console.log("initDraw - changed: touch -> pen pointer ID");
                    console.log("initDraw - initialized: pathRef.current...");
                    pathRef.current = null;
                } else {
                    // 다른 포인터 ID도 무시
                    console.log("initDraw - ignored: different pointer ID");
                    return;
                }
            }
        }

        let classtalk = document.getElementById("classtalk");
        if (classtalk) classtalk.style.zIndex = 30;

        let studentArea = document.getElementById("student-area");
        if (studentArea) studentArea.style.zIndex = 35;

        let teacherArea = document.getElementById("teacher-area");
        if (teacherArea) teacherArea.style.zIndex = 35;

        handleSelectedDrawingToolFunc({ selectedFunc: "SET_DRAWING_STATUS", data: { isDrawingInkStroke: true } });

        let offsetY = targetRef.current.scrollTop;
        if (offsetY === undefined || offsetY < 0) offsetY = 0;

        let pointX = 0, pointY = 0;

        /* // original
        if (e.type === 'pointerdown') {
            pointX = e.x;
            pointY = offsetY + e.y;
        } else {
            pointX = e.offsetX;
            pointY = e.offsetY;
        } */

        pointX = e.offsetX;
        pointY = e.offsetY;

        // console.log(e, pointX, pointY);

        let point = { x: Math.round((pointX / scale_x.current) * 10) / 10, y: Math.round((pointY / scale_y.current) * 10) / 10 };

        if (pathRef.current === null) {
            // 새로운 그리기 시작
            if (lDrawingMode.current === enDrawingMode.Pen || lDrawingMode.current === enDrawingMode.Marker) {
                pathRef.current = {};
                pathRef.current.isDrawing = true;
                pathRef.current.id = e.pointerId;
                // pathRef에 pointerType 저장 (현재 그리기 세션이 어떤 입력 장치로 시작되었는지 저장)
                pathRef.current.pointerType = e.pointerType; // 'pen', 'touch', 'mouse' 저장

                // drawing 시 쓰이는 컬러 rgb(0~255) / rgba(0~255, 0~1)
                let cur_color = { ...lDrawingTipColor.current, A: (lDrawingMode.current === enDrawingMode.Pen ? 1 : 0.5) };
                let cur_thick = (lDrawingMode.current === enDrawingMode.Pen ? lDrawingTipSize.current : (lDrawingTipSize.current * 2.5));

                pathRef.current.stroke = {};
                pathRef.current.stroke.DrawingAttributes = { Color: cur_color, lineWidth: cur_thick };
                pathRef.current.stroke.StylusPoints = [];

                mainCtxRef.current = canvasRef.current.getContext('2d');
                mainCtxRef.current.lineWidth = cur_thick;
                mainCtxRef.current.lineJoin = 'round';
                mainCtxRef.current.lineCap = 'round';
                // 260819: 실시간 그리기 이음매 얼룩 방지 위해 캔버스에는 항상 불투명(A=1)으로 그리고,
                // 실제 투명도는 캔버스 레이어의 CSS opacity로 적용 ... by Easy
                mainCtxRef.current.strokeStyle = 'rgba(' + cur_color.R + ',' + cur_color.G + ',' + cur_color.B + ',1)';
                mainCtxRef.current.fillStyle = 'rgba(' + cur_color.R + ',' + cur_color.G + ',' + cur_color.B + ',1)';
                canvasRef.current.style.opacity = cur_color.A;

                pathRef.current.minPoints = { x: point.x, y: point.y };
                pathRef.current.maxPoints = { x: point.x, y: point.y };

                // 20260701: 아래 onPaint 호출이 이 point를 StylusPoints에 push하므로
                // 여기서 별도로 push하지 않는다 (중복 push 방지)
                onPaint(mainCtxRef.current, pathRef.current, { x: point.x, y: point.y });
            } else if (lDrawingMode.current === enDrawingMode.EraseStroke) {
                // console.log(annotList);
                pathRef.current = {};
                pathRef.current.isDrawing = true;
                pathRef.current.id = e.pointerId;

                pathRef.current.preEraserPoint = point;
                erase(pathRef.current, point);
            }
        }/*  else if (pathRef.current.isDrawing) {
            // 이미 그리기가 진행 중일 때
            // Palm rejection: 펜으로 그리는 중에는 터치 입력 무시
            if (pathRef.current.pointerType === 'pen' && e.pointerType === 'touch') {
                // 펜으로 그리는 중 손바닥 터치는 무시
                console.log("initDraw - pathRef.current.pointerType is pen & e.pointerType is touch");
                return;
            }

            // 손가락으로 그리는 중에는 추가 터치나 펜 입력 무시 (첫 번째 포인터만 허용)
            if (e.pointerId !== pathRef.current.id) {
                console.log("initDraw - pathRef.current.id and e.pointerId is different");
                return;
            }
        } else {
            // pathRef.current가 null이 아니지만 그리기도 진행 중이 아닌 경우
            console.log("initDraw - pathRef.current.isDrawing[", pathRef.current.isDrawing, "]");
            console.log("initDraw - pathRef.current.pointerType[", pathRef.current.pointerType, "], e.pointerType[", e.pointerType, "]");
            console.log("initDraw - pathRef.current.id[", pathRef.current.id, "], e.pointerId[", e.pointerId, "]");
        } */
    }

    const draw = (e) => {
        // console.log("draw - e.pointerType[", e.pointerType, "]");
        if (pathRef.current && pathRef.current.isDrawing) {
            // Palm rejection: 펜으로 그리는 중 터치 이벤트는 무시
            if (pathRef.current.pointerType === 'pen' && e.pointerType === 'touch') {
                console.log("draw - pathRef.current.pointerType is pen & e.pointerType is touch");
                return;
            }

            // 동일한 pointerId만 처리 (멀티터치 방지)
            if (pathRef.current.id !== e.pointerId) {
                // console.log("draw - pathRef.current.pointerType[", pathRef.current.pointerType, "], e.pointerType[", e.pointerType, "]");
                // console.log("draw - pathRef.current.id[", pathRef.current.id, "], e.pointerId[", e.pointerId, "]");

                // 다른 포인터 ID도 무시
                console.log("draw - ignored: different pointer ID");
                return;
            }

            let offsetY = targetRef.current.scrollTop;
            if (offsetY === undefined || offsetY < 0) offsetY = 0;

            let pointX = 0, pointY = 0;

            /* original
            if (e.type === 'pointermove') {
                pointX = e.x;
                pointY = offsetY + e.y;
            } else {
                pointX = e.offsetX;
                pointY = e.offsetY;
            } */

            pointX = e.offsetX;
            pointY = e.offsetY;

            // console.log(e, pointX, pointY);

            let point = { x: Math.round((pointX / scale_x.current) * 10) / 10, y: Math.round((pointY / scale_y.current) * 10) / 10 };
            // let point = { x: pointX, y: pointY };

            if (lDrawingMode.current === enDrawingMode.Pen || lDrawingMode.current === enDrawingMode.Marker) {
                if (pathRef.current.minPoints.x > point.x) pathRef.current.minPoints.x = point.x;
                if (pathRef.current.minPoints.y > point.y) pathRef.current.minPoints.y = point.y;

                let brushThick = mainCtxRef.current.lineWidth / 2;
                if (pointX < (canvasRef.current.width - brushThick) && pathRef.current.maxPoints.x < point.x) pathRef.current.maxPoints.x = point.x;
                if (pointY < (canvasRef.current.height - brushThick) && pathRef.current.maxPoints.y < point.y) pathRef.current.maxPoints.y = point.y;
                // if (pathRef.current.maxPoints.x < point.x) pathRef.current.maxPoints.x = point.x;
                // if (pathRef.current.maxPoints.y < point.y) pathRef.current.maxPoints.y = point.y;

                if (pointX < (canvasRef.current.width - brushThick) && pointY < (canvasRef.current.height - brushThick)) {
                    onPaint(mainCtxRef.current, pathRef.current, { x: point.x, y: point.y });
                }
            } else if (lDrawingMode.current === enDrawingMode.EraseStroke) {
                erase(pathRef.current, point);
                pathRef.current.preEraserPoint = point;
            }
        } else {
            /* if (pathRef.current) {
                // pathRef.current가 null이 아니지만 그리기도 진행 중이 아닌 경우
                console.log("draw - pathRef.current.isDrawing[", pathRef.current.isDrawing, "]");
                console.log("draw - pathRef.current.pointerType[", pathRef.current.pointerType, "], e.pointerType[", e.pointerType, "]");
                console.log("draw - pathRef.current.id[", pathRef.current.id, "], e.pointerId[", e.pointerId, "]");
            } */
        }
    }

    const finishDraw = (e) => {
        // console.log("finishDraw - e.pointerType[", e.pointerType, "]");
        if (pathRef.current && pathRef.current.isDrawing) {
            // Palm rejection: 펜으로 그리는 중 터치 이벤트는 무시
            if (pathRef.current.pointerType === 'pen' && e.pointerType === 'touch') {
                console.log("finishDraw - pathRef.current.pointerType is pen & e.pointerType is touch");
                return;
            }

            // 동일한 pointerId만 처리
            if (pathRef.current.id !== e.pointerId) {
                // console.log("finishDraw - pathRef.current.pointerType[", pathRef.current.pointerType, "], e.pointerType[", e.pointerType, "]");
                // console.log("finishDraw - pathRef.current.id[", pathRef.current.id, "], e.pointerId[", e.pointerId, "]");

                // 손가락으로 잉크 스트로크를 그리던 중 손바닥이 화면에 닿는 경우 처리 ... by hjkim 20251027
                if (pathRef.current.pointerType === 'touch' && e.pointerType === 'touch') {
                    // path 무효 처리
                    // zIndex 초기화

                    pathRef.current.isDrawing = false;
                    pathRef.current = null;

                    handleSelectedDrawingToolFunc({ selectedFunc: "SET_DRAWING_STATUS", data: { isDrawingInkStroke: false } });

                    let classtalk = document.getElementById("classtalk");
                    if (classtalk) classtalk.style.zIndex = 50;

                    let studentArea = document.getElementById("student-area");
                    if (studentArea) studentArea.style.zIndex = 45;

                    let teacherArea = document.getElementById("teacher-area");
                    if (teacherArea) teacherArea.style.zIndex = 45;
                } else {
                    // 다른 포인터 ID도 무시
                    console.log("finishDraw - ignored: different pointer ID");
                }
                return;
            }

            if (lDrawingMode.current === enDrawingMode.Pen || lDrawingMode.current === enDrawingMode.Marker) {
                // 20260701: 증분 렌더링 중 아직 캔버스에 반영되지 않은 마지막 구간을 확정해서 그림
                onPaint(mainCtxRef.current, pathRef.current, undefined, true);

                // 260819: 실시간 드로잉 경로 - isOpaquePaint=true로 CSS opacity 적용 ... by Easy
                let newAnnot = createInkStrokeAnnot({ width: scale_x.current, height: scale_y.current }, pathRef.current, mainCtxRef.current, true);
                annotList.current.push(newAnnot);

                handleSelectedDrawingToolFunc({ selectedFunc: "SEND_STROKE", data: { StylusPoints: pathRef.current.stroke.StylusPoints, DrawingAttributes: pathRef.current.stroke.DrawingAttributes, mode: lDrawingMode.current } });

                pathRef.current.isDrawing = false;
                pathRef.current = null;
            } else if (lDrawingMode.current === enDrawingMode.EraseStroke) {
                draw(e);
                pathRef.current.isDrawing = false;
                pathRef.current = null;
            }
        }/*  else {
            if (pathRef.current) {
                // pathRef.current가 null이 아니지만 그리기도 진행 중이 아닌 경우
                console.log("finishDraw - pathRef.current.isDrawing[", pathRef.current.isDrawing, "]");
                console.log("finishDraw - pathRef.current.pointerType[", pathRef.current.pointerType, "], e.pointerType[", e.pointerType, "]");
                console.log("finishDraw - pathRef.current.id[", pathRef.current.id, "], e.pointerId[", e.pointerId, "]");
            }
        } */

        handleSelectedDrawingToolFunc({ selectedFunc: "SET_DRAWING_STATUS", data: { isDrawingInkStroke: false } });

        let classtalk = document.getElementById("classtalk");
        if (classtalk) classtalk.style.zIndex = 50;

        let studentArea = document.getElementById("student-area");
        if (studentArea) studentArea.style.zIndex = 45;

        let teacherArea = document.getElementById("teacher-area");
        if (teacherArea) teacherArea.style.zIndex = 45;
    }

    /**
     * Server Drawing Path
     * (Windows & Android connect bluetooth Pen)
     */
    const server_initDraw = (point) => {
        if (!serverPathRef.current) {
            if (!(rcvMode === enDrawingMode.Pen || rcvMode === enDrawingMode.Marker)) return;

            let color = { ...rcvColor, A: (rcvMode === enDrawingMode.Pen ? 1 : 0.5) };

            serverPathRef.current = {};
            serverPathRef.current.stroke = {};
            serverPathRef.current.stroke.DrawingAttributes = { Color: color, lineWidth: rcvWidth };
            serverPathRef.current.stroke.StylusPoints = [];

            serverPathRef.current.count = 0;

            // 만약 선생님과 동시에 그릴 때, 색상이 바껴버리면 컨텍스트 구분하기
            /*let canvas = document.createElement('canvas');
            canvas.style.position = 'absolute';
            canvas.style.top = 0;
            canvas.style.left = 0;
            canvas.width = canvasRef.current.width;
            canvas.height = canvasRef.current.height;
            
            let drawingCanvas = document.getElementById('serverCanvas');
            drawingCanvas.appendChild(canvas);
            */

            let context = sCanvasRef.current.getContext('2d');
            context.lineWidth = rcvWidth;
            context.lineJoin = 'round';
            context.lineCap = 'round';
            // 260819: 실시간 그리기 이음매 얼룩 방지 위해 캔버스에는 항상 불투명(A=1)으로 그리고,
            // 실제 투명도는 캔버스 레이어의 CSS opacity로 적용 ... by Easy
            context.strokeStyle = 'rgba(' + color.R + ',' + color.G + ',' + color.B + ',1)';
            context.fillStyle = 'rgba(' + color.R + ',' + color.G + ',' + color.B + ',1)';
            sCanvasRef.current.style.opacity = color.A;

            serverPathRef.current.minPoints = { x: point.X, y: point.Y };
            serverPathRef.current.maxPoints = { x: point.X, y: point.Y };
            serverPathRef.current.canvas = sCanvasRef.current;

            // 20260701: onPaint이 point를 StylusPoints에 push하므로 여기서 중복 push하지 않음
            onPaint(context, serverPathRef.current, { x: point.X, y: point.Y });
        }
    }

    const server_draw = (point) => {
        if (serverPathRef.current === undefined || serverPathRef.current === null) return;

        if (!(rcvMode === enDrawingMode.Pen || rcvMode === enDrawingMode.Marker)) return;

        // 20260701: onPaint을 증분 렌더링으로 바꾸면서 포인트당 그리기 비용이 O(1)이 됐기 때문에,
        // 예전에 성능 때문에 포인트를 5개 중 1개만 그리던 로직(count % 5)을 제거함.
        // (포인트를 버리면 빠르게 움직인 구간에서 각지고 지그재그로 그려지는 원인이었음)
        serverPathRef.current.count++;

        if (serverPathRef.current.minPoints.x > point.X) serverPathRef.current.minPoints.x = point.X;
        if (serverPathRef.current.minPoints.y > point.Y) serverPathRef.current.minPoints.y = point.Y;

        if (serverPathRef.current.maxPoints.x < point.X) serverPathRef.current.maxPoints.x = point.X;
        if (serverPathRef.current.maxPoints.y < point.Y) serverPathRef.current.maxPoints.y = point.Y;

        // 20260701: onPaint이 point를 StylusPoints에 push하므로 여기서 중복 push하지 않음
        onPaint(serverPathRef.current.canvas.getContext('2d'), serverPathRef.current, { x: point.X, y: point.Y });
    }

    const server_finishDraw = (point) => {
        if (serverPathRef.current === undefined || serverPathRef.current === null) return;

        if (!(rcvMode === enDrawingMode.Pen || rcvMode === enDrawingMode.Marker)) return;


        // 20260701: 증분 렌더링 중 아직 캔버스에 반영되지 않은 마지막 구간을 확정해서 그림
        onPaint(serverPathRef.current.canvas.getContext('2d'), serverPathRef.current, undefined, true);

        //let newAnnot = createInkStrokeAnnot( { width: scale_x.current, height: scale_y.current }, serverPathRef.current, sCtxRef.current);
        // 260819: 실시간 드로잉 경로 - isOpaquePaint=true로 CSS opacity 적용 ... by Easy
        let newAnnot = createInkStrokeAnnot({ width: scale_x.current, height: scale_y.current }, serverPathRef.current, serverPathRef.current.canvas.getContext('2d'), true);
        annotList.current.push(newAnnot);

        serverPathRef.current.count = -1;
        serverPathRef.current = null;
    }

    const server_eraseStroke = (spoint, epoint) => {
        deleteInk(annotList.current, { x: spoint.X, y: spoint.Y }, { x: epoint.X, y: epoint.Y });
    }

    const draw1Stroke = (stroke) => {
        if (stroke === undefined || stroke === null) return;

        if (stroke.DrawingAttributes === undefined || stroke.DrawingAttributes === null) return;

        console.log(stroke.DrawingAttributes);

        let rcvPathRef = {};
        let color = { ...stroke.DrawingAttributes.Color, A: stroke.DrawingAttributes.IsHighlighter ? 0.5 : 1 };
        let lineWidth = stroke.DrawingAttributes.lineWidth;

        rcvPathRef.stroke = {};
        rcvPathRef.stroke.DrawingAttributes = { Color: color, lineWidth: lineWidth };
        rcvPathRef.stroke.StylusPoints = stroke.StylusPoints;
        rcvPathRef.minPoints = stroke.minPoints;
        rcvPathRef.maxPoints = stroke.maxPoints;

        rcvCtxRef.current = rcvCanvasRef.current.getContext('2d');
        rcvCtxRef.current.lineWidth = lineWidth;
        rcvCtxRef.current.lineJoin = 'round';
        rcvCtxRef.current.lineCap = 'round';
        rcvCtxRef.current.strokeStyle = 'rgba(' + color.R + ', ' + color.G + ', ' + color.B + ', ' + color.A + ')';
        rcvCtxRef.current.fillStyle = 'rgba(' + color.R + ', ' + color.G + ', ' + color.B + ', ' + color.A + ')';

        // 20260701: 이미 완성된 스트로크 전체를 한 번에 그리는 경우이므로 isFinal=true로 끝점까지 확정
        onPaint(rcvCtxRef.current, rcvPathRef, undefined, true);

        let newAnnot = createInkStrokeAnnot({ width: scale_x.current, height: scale_y.current }, rcvPathRef, rcvCtxRef.current);
        annotList.current.push(newAnnot);
    }

    const drawNStroke = (strokes) => {
        if (strokes === undefined || strokes === null) return;

        strokes.forEach(stroke => {
            draw1Stroke(stroke);
        });
    }

    /**
     * Smart Pen (Windows)
     * Windows connect bluetooth Pen
     */
    const onRcvExtensionMessage = (e) => {
        if (e.data && e.data.msg) {
            const { msg } = e.data;
            switch (msg.msg) {
                case 'PenDown':
                    pen_initDraw({ X: msg.X_Position, Y: msg.Y_Position });
                    break;

                case 'PenMove':
                    pen_draw({ X: msg.X_Position, Y: msg.Y_Position });
                    break;

                case 'PenUp':
                    pen_finishDraw({ X: msg.X_Position, Y: msg.Y_Position });
                    break;

                default:
                    break;
            }
        }
    }

    const pen_initDraw = (point) => {
        if (!penPathRef.current) {
            if (lDrawingMode.current === enDrawingMode.Pen || lDrawingMode.current === enDrawingMode.Marker) {
                // 260819: 실시간 그리기 이음매 얼룩 방지 위해 캔버스에는 항상 불투명(A=1)으로 그리고,
                // 실제 투명도는 캔버스 레이어의 CSS opacity로 적용 ... by Easy
                let penAlpha = (lDrawingMode.current === enDrawingMode.Pen ? 1 : 0.3);

                penPathRef.current = {};
                penPathRef.current.stroke = {};
                penPathRef.current.stroke.DrawingAttributes = { Color: { ...rcvColor, A: penAlpha }, lineWidth: rcvWidth };
                penPathRef.current.stroke.StylusPoints = [];

                pCtxRef.current = pCanvasRef.current.getContext('2d');
                pCtxRef.current.lineWidth = rcvWidth;
                pCtxRef.current.lineJoin = 'round';
                pCtxRef.current.lineCap = 'round';
                pCtxRef.current.strokeStyle = 'rgba(' + rcvColor.r + ', ' + rcvColor.g + ', ' + rcvColor.b + ', 1)';
                pCtxRef.current.fillStyle = 'rgba(' + rcvColor.r + ', ' + rcvColor.g + ', ' + rcvColor.b + ', 1)';
                pCanvasRef.current.style.opacity = penAlpha;

                penPathRef.current.minPoints = { x: point.x, y: point.y };
                penPathRef.current.maxPoints = { x: point.x, y: point.y };

                // 20260701: onPaint이 point를 StylusPoints에 push하므로 여기서 중복 push하지 않음
                onPaint(pCtxRef.current, penPathRef.current, { x: point.x, y: point.y });
            }
        }
    }

    const pen_draw = (point) => {
        if (penPathRef.current === undefined || penPathRef.current === null) return;

        if (lDrawingMode.current === enDrawingMode.Pen || lDrawingMode.current === enDrawingMode.Marker) {
            if (penPathRef.current.minPoints.x > point.x) penPathRef.current.minPoints.x = point.x;
            if (penPathRef.current.minPoints.y > point.y) penPathRef.current.minPoints.y = point.y;

            if (penPathRef.current.maxPoints.x < point.x) penPathRef.current.maxPoints.x = point.x;
            if (penPathRef.current.maxPoints.y < point.y) penPathRef.current.maxPoints.y = point.y;

            onPaint(pCtxRef.current, penPathRef.current, { x: point.x, y: point.y });
        }
    }

    const pen_finishDraw = (point) => {
        if (penPathRef.current === undefined || penPathRef.current === null) return;

        if (lDrawingMode.current === enDrawingMode.Pen || lDrawingMode.current === enDrawingMode.Marker) {
            penPathRef.current.isDrawing = false;

            // 20260701: 증분 렌더링 중 아직 캔버스에 반영되지 않은 마지막 구간을 확정해서 그림
            onPaint(pCtxRef.current, penPathRef.current, undefined, true);

            // 260819: 실시간 드로잉 경로 - isOpaquePaint=true로 CSS opacity 적용 ... by Easy
            let newAnnot = createInkStrokeAnnot({ width: scale_x.current, height: scale_y.current }, penPathRef.current, pCtxRef.current, true);
            annotList.current.push(newAnnot);

            penPathRef.current = null;
        }
    }

    /**
     * Smart Pen (Android)
     * Android connect bluetooth Pen
     */

    const android_pen_initDraw = (point) => {
        if (!aPenPathRef.current) {
            if (!(lDrawingMode.current === enDrawingMode.Pen || lDrawingMode.current === enDrawingMode.Marker)) return;

            // 260819: 실시간 그리기 이음매 얼룩 방지 위해 캔버스에는 항상 불투명(A=1)으로 그리고,
            // 실제 투명도는 캔버스 레이어의 CSS opacity로 적용 ... by Easy
            let androidAlpha = (lDrawingMode.current === enDrawingMode.Pen ? 1 : 0.3);

            aPenPathRef.current = {};
            aPenPathRef.current.stroke = {};
            aPenPathRef.current.stroke.DrawingAttributes = { Color: { ...lDrawingTipColor.current, A: androidAlpha }, lineWidth: lDrawingTipSize.current };
            aPenPathRef.current.stroke.StylusPoints = [];

            aCtxRef.current = aCanvasRef.current.getContext('2d');
            aCtxRef.current.lineWidth = lDrawingTipSize.current;
            aCtxRef.current.lineJoin = 'round';
            aCtxRef.current.lineCap = 'round';
            aCtxRef.current.strokeStyle = 'rgba(' + lDrawingTipColor.current.R + ', ' + lDrawingTipColor.current.G + ', ' + lDrawingTipColor.current.B + ', 1)';
            aCtxRef.current.fillStyle = 'rgba(' + lDrawingTipColor.current.R + ', ' + lDrawingTipColor.current.G + ', ' + lDrawingTipColor.current.B + ', 1)';
            aCanvasRef.current.style.opacity = androidAlpha;

            aPenPathRef.current.minPoints = { x: point.X, y: point.Y };
            aPenPathRef.current.maxPoints = { x: point.X, y: point.Y };

            // 20260701: onPaint이 point를 StylusPoints에 push하므로 여기서 중복 push하지 않음
            onPaint(aCtxRef.current, aPenPathRef.current, { x: point.X, y: point.Y });
        }
    }

    const android_pen_draw = (point) => {
        if (aPenPathRef.current === undefined || aPenPathRef.current === null) return;

        if (lDrawingMode.current === enDrawingMode.Pen || lDrawingMode.current === enDrawingMode.Marker) {
            if (aPenPathRef.current.minPoints.x > point.X) aPenPathRef.current.minPoints.x = point.X;
            if (aPenPathRef.current.minPoints.y > point.Y) aPenPathRef.current.minPoints.y = point.Y;

            if (aPenPathRef.current.maxPoints.x < point.X) aPenPathRef.current.maxPoints.x = point.X;
            if (aPenPathRef.current.maxPoints.y < point.Y) aPenPathRef.current.maxPoints.y = point.Y;

            onPaint(aCtxRef.current, aPenPathRef.current, { x: point.X, y: point.Y });
        }
    }

    const android_pen_double_draw = (point1, point2) => {
        if (aPenPathRef.current === undefined || aPenPathRef.current === null) return;

        if (lDrawingMode.current === enDrawingMode.Pen || lDrawingMode.current === enDrawingMode.Marker) {
            let minPointX, minPointY, maxPointX, maxPointY;
            if (point1.X < point2.X) {
                minPointX = point1.X;
                maxPointX = point2.X;
            } else {
                maxPointX = point1.X;
                minPointX = point2.X;
            }

            if (point1.Y < point2.Y) {
                minPointY = point1.Y;
                maxPointY = point2.Y;
            } else {
                maxPointY = point1.Y;
                minPointY = point2.Y;
            }

            if (aPenPathRef.current.minPoints.x > minPointX) aPenPathRef.current.minPoints.x = minPointX;
            if (aPenPathRef.current.minPoints.y > minPointY) aPenPathRef.current.minPoints.y = minPointY;

            if (aPenPathRef.current.maxPoints.x < maxPointX) aPenPathRef.current.maxPoints.x = maxPointX;
            if (aPenPathRef.current.maxPoints.y < maxPointY) aPenPathRef.current.maxPoints.y = maxPointY;

            //let prePoint = aPenPath.current.lastSegment.point;
            //aPenPath.current.quadraticCurveTo(prePoint, new Point(cp1.x, cp1.y));
            //aPenPath.current.quadraticCurveTo(new Point(cp1.x, cp1.y), new Point(cp2.x, cp2.y));

            aPenPathRef.current.stroke.StylusPoints.push({ x: point1.X, y: point1.Y });
            //onPaint(aCtxRef.current, aPenPathRef.current, { x: point1.x, y: point1.y });
            onPaint(aCtxRef.current, aPenPathRef.current, { x: point2.X, y: point2.Y });
        }
    }

    const android_pen_finishDraw = (point) => {
        if (aPenPathRef.current === undefined || aPenPathRef.current === null) return;

        if (lDrawingMode.current === enDrawingMode.Pen || lDrawingMode.current === enDrawingMode.Marker) {
            aPenPathRef.current.isDrawing = false;

            aCtxRef.current = aCanvasRef.current.getContext('2d');

            // 20260701: 증분 렌더링 중 아직 캔버스에 반영되지 않은 마지막 구간을 확정해서 그림
            onPaint(aCtxRef.current, aPenPathRef.current, undefined, true);

            // 260819: 실시간 드로잉 경로 - isOpaquePaint=true로 CSS opacity 적용 ... by Easy
            let newAnnot = createInkStrokeAnnot({ width: scale_x.current, height: scale_y.current }, aPenPathRef.current, aCtxRef.current, true);
            annotList.current.push(newAnnot);

            aPenPathRef.current = null;
        }
    }

    return (
        <div className="live-area canvas">
            <div id="canvas-area" ref={targetRef}>
                <canvas
                    id="backgroundCanvas"
                    className="bg-canvas"
                    ref={bgCanvasRef}
                    width={ConstData.SCREEN_RATE.WIDTH}
                    height={ConstData.SCREEN_RATE.HEIGHT}
                />
                <canvas
                    id="serverCanvas"
                    className="draw-canvas"
                    ref={sCanvasRef}
                />
                <canvas
                    id="androidCanvas"
                    className="draw-canvas"
                    ref={aCanvasRef}
                />
                <canvas
                    id="penCanvas"
                    className="draw-canvas"
                    ref={pCanvasRef}
                />
                <canvas
                    id="smallGroupCanvas"
                    className="draw-canvas"
                    ref={rcvCanvasRef}
                />
                <canvas
                    id="drawingCanvas"
                    className="draw-canvas"
                    ref={canvasRef}
                />
            </div>
        </div>
    )
}
export default LiveDrawingCanvas;